import CategoryCard1 from "./CategoryCard1.presenter";

export default CategoryCard1;
